import { useState, type PropsWithChildren } from "react";

export default function CompanySidebar({ children }: PropsWithChildren) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <div className="min-h-screen bg-gray-100">
            <aside className="fixed top-0 left-0 h-full w-0 lg:w-64 bg-[#9C9C9A] text-white transition-all duration-300 z-20 overflow-hidden">
                <div className="flex flex-col h-full">
                    <div className="p-5 transition-opacity duration-200 hover:opacity-80 cursor-pointer">
                        <img
                            className="h-[60px] w-auto"
                            src="https://www.saaf.org.ar/wp-content/uploads/2024/11/logosaaf.webp"
                            alt="logo"
                        />
                    </div>
                    <nav className="mt-2 px-2">
                        <ul className="space-y-1">
                            <li>
                                <a
                                    href="#"
                                    className="block p-3 rounded hover:bg-gray-600 transition"
                                >
                                    Perfil empresarial
                                </a>
                            </li>
                            <li>
                                <a className="cursor-pointer block p-3 rounded hover:bg-gray-600 transition">
                                    Publicaciones
                                </a>
                            </li>
                            <li>
                                <a className="cursor-pointer block p-3 rounded hover:bg-gray-600 transition">
                                    Postulantes
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>

            <div className="lg:ml-64 transition-all duration-300">
                <header className="bg-[#9C9C9A] p-4 sticky top-0 z-10 flex justify-between items-center h-[90px]">
                    <div
                        className="text-white pl-2 font-bold lg:invisible 
                transition-opacity duration-200 hover:opacity-80 cursor-pointer"
                    >
                        <img
                            className="h-[60px] w-auto"
                            src="https://www.saaf.org.ar/wp-content/uploads/2024/11/logosaaf.webp"
                            alt="logo"
                        />
                    </div>

                    <button
                        className="text-white text-2xl cursor-pointer lg:hidden
                     hover:text-yellow-200"
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        ☰
                    </button>
                </header>

                <div
                    className={`lg:hidden bg-[#9C9C9A] overflow-hidden transition-all duration-300 ${
                        isMenuOpen ? "max-h-60" : "max-h-0"
                    }`}
                >
                    <nav className="px-4 py-2">
                        <ul className="space-y-2">
                            <li>
                                <a
                                    href="#"
                                    className="block px-2 py-2 text-white rounded hover:bg-gray-600 transition"
                                >
                                    Perfil empresarial
                                </a>
                            </li>
                            <li>
                                <a className="cursor-pointer block px-2 py-2 text-white rounded hover:bg-gray-600 transition">
                                    Publicaciones
                                </a>
                            </li>
                            <li>
                                <a className="cursor-pointer  block px-2 py-2 text-white rounded hover:bg-gray-600 transition">
                                    Postulantes
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <main className="p-10">{children}</main>
            </div>
        </div>
    );
}
